"use client";
import { jsx, Fragment } from "react/jsx-runtime";
import { ContentType } from "../../../enums/contentStack.js";
import { isBD } from "../../../utils/businessType.lib.js";
import { useState, useMemo, useEffect } from "react";
import { Skeleton } from "@mui/material";
import "../../Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../Chrome/BrowseContext/hook.js";
import { AnnouncementBannerSkeleton } from "../../Chrome/Header/AnnouncementBanner/AnnouncementBannerSkeleton.js";
import { AdBuilderSkeleton } from "../../Marketing/AdBuilder/AdBuilderUI/view.skeleton.js";
import { FeatureHighlightCardV2Skeleton } from "../../Marketing/FeatureHighlightCardv2/FeatureHighlightCardV2Skeleton.js";
import { RichTextEntrySkeleton } from "../../Media/RichTextEntry/RichTextEntrySkeleton.js";
import { findMatchingRuleByAttributes } from "./utils.js";
const SegmentBasedEntryClient = ({
  defaultContentType,
  ReferenceEntriesComponentMap,
  entry,
  adBuilderSx
}) => {
  const { bdWarehouseNumber, warehouse } = useBrowseContext();
  const [entryData, setEntryData] = useState();
  const warehouseId = useMemo(() => {
    var _a;
    return isBD() ? bdWarehouseNumber == null ? void 0 : bdWarehouseNumber.value : (_a = warehouse == null ? void 0 : warehouse.nearestWarehouse) == null ? void 0 : _a.catalog;
  }, [bdWarehouseNumber, warehouse]);
  useEffect(() => {
    var _a;
    if (typeof window !== "undefined") {
      const targetRules = entry == null ? void 0 : entry.target_rules_block;
      const matchingReference = findMatchingRuleByAttributes(
        targetRules,
        {
          warehouseId
        }
      );
      setEntryData(
        matchingReference || ((_a = entry == null ? void 0 : entry.base_content_reference) == null ? void 0 : _a[0])
      );
    }
  }, [warehouseId]);
  if (!entryData) {
    switch (defaultContentType) {
      case ContentType.AdBuilder:
        return /* @__PURE__ */ jsx(AdBuilderSkeleton, { sx: adBuilderSx });
      case ContentType.AnnouncementBanner:
        return /* @__PURE__ */ jsx(AnnouncementBannerSkeleton, {});
      case ContentType.FeatureHighlightCardV2:
        return /* @__PURE__ */ jsx(FeatureHighlightCardV2Skeleton, {});
      case ContentType.CustomRichText:
        return /* @__PURE__ */ jsx(RichTextEntrySkeleton, {});
      case ContentType.LinkListWithFlyoutReferences:
      case ContentType.LinkListSimple:
      case ContentType.LinkListWithFlyout:
      case ContentType.LinkFlyout:
        return /* @__PURE__ */ jsx(Skeleton, { variant: "rectangular", height: "32" });
      default:
        return null;
    }
  }
  const Component = ReferenceEntriesComponentMap[entryData == null ? void 0 : entryData.uid];
  if (Component) {
    return Component;
  }
  return /* @__PURE__ */ jsx(Fragment, {});
};
export {
  SegmentBasedEntryClient
};
